import { useAuth } from 'react-oidc-context';

export const useAuthHeaders = () => {
  const auth = useAuth();

  const getAuthHeaders = (json:boolean=true): Record<string, string> => {
    if (!auth.user?.access_token) {
      throw new Error('No access token available');
    }
    if(json){
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auth.user.access_token}`,
    };
  }else{
    return {
      Authorization: `Bearer ${auth.user.access_token}`,
    };
  }
  };

  return { getAuthHeaders, isAuthenticated: auth.isAuthenticated };
};